export const productTypes = [
    { category: "Childrenswear", itemType: "Childrenswear" },
    { category: "Childrenswear", itemType: "Childrens Shoes" },

    { category: "Feeding", itemType: "Feeding Equipment" },
    { category: "Feeding", itemType: "High Chairs and Seats" },
    { category: "Feeding", itemType: "Feeding Pillow" },
    { category: "Feeding", itemType: "Feeding Accessories" },

    { category: "Safety", itemType: "Safety Gates & Guards" },
    { category: "Safety", itemType: "Baby Monitors" },
    { category: "Safety", itemType: "Safety Accessories" },

    { category: "Maternity", itemType: "Dresses" },
    { category: "Maternity", itemType: "Trousers" },
    { category: "Maternity", itemType: "Tops" },
    { category: "Maternity", itemType: "Coats" },
    { category: "Maternity", itemType: "Mixed Items" },

    { category: "Nursery", itemType: "Furniture" },
    { category: "Nursery", itemType: "Mobile & Night Lights" },
    { category: "Nursery", itemType: "Curtains" },
    { category: "Nursery", itemType: "Storage" },

    { category: "Play", itemType: "Baby & Toddler Toys" },
    { category: "Play", itemType: "Bouncers, Swings & Walkers" },
    { category: "Play", itemType: "Childrens Books" },
    { category: "Play", itemType: "Playmats" },

    { category: "Pregnancy", itemType: "Hospital Bag Essentials" },
    { category: "Pregnancy", itemType: "Pregnancy Pillows" },
    { category: "Pregnancy", itemType: "Birth Supplies" },
    { category: "Pregnancy", itemType: "Ten Machines" },

    { category: "Sleep", itemType: "Cot, Cotbeds & Toddler Beds" },
    { category: "Sleep", itemType: "Sleep Pods & Nests" },
    { category: "Sleep", itemType: "Co-Sleepers" },
    { category: "Sleep", itemType: "Travel Cots" },
    { category: "Sleep", itemType: "Moses Baskets" },
    { category: "Sleep", itemType: "Bedding" },
    { category: "Sleep", itemType: "Sleeping Bags and Swaddles" },

    // Travel subcategories have SEO pages (util/categorySeo.js), so the stored value is a
    // comma-free key: search URLs read a comma as "OR" (pub_productItemType=a,b).
    { category: "Travel", itemType: "Buggies, Prams & Pushchairs", value: "buggies-prams-pushchairs" },
    { category: "Travel", itemType: "Travel System Bundles", value: "travel-system-bundles" },
    { category: "Travel", itemType: "Baby Carriers, Slings and Travel Accessories", value: "carriers-slings-travel-accessories" },
]

// Stored publicData.productItemType value; most item types store their label.
const itemTypeValue = item => item.value || item.itemType;

export const getCategories = () => [...new Set(productTypes.map(item => item.category))];

export const getItemTypesForCategory = (category) => {
    return productTypes
        .filter(item => item.category === category && item.itemType !== undefined)
        .map(item => ({ value: itemTypeValue(item), label: item.itemType }));
};

// Label for a stored productItemType; values no longer in the list are shown as stored.
export const getItemTypeLabel = (value) => {
    const found = productTypes.find(item => itemTypeValue(item) === value);
    return found ? found.itemType : value;
};


export const getCategoriesForFilter = () => {
    return getCategories().map(c => {
        return { option: c, label: c }
    })
}